/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { ChoiceGroup } from '@bingads-webui-react/fabric-control';

export const EditThumbnail = (props) => {
  const {
    i18n,
    onThumbnailModeChanged,
    mode,
  } = props;

  return (
    <div className="thumbnail-edit-container">
      <div className="description">{i18n.getString('ImageExperience_ThumbnailDescription')}</div>
      <ChoiceGroup
        onChange={(_ev, option) => onThumbnailModeChanged(option.key)}
        selectedKey={mode}
        options={[
          {
            key: 'Automatic',
            text: `${i18n.getString('ImageExperience_AutomaticThumbnail')} - ${i18n.getString('ImageExperience_AutomaticThumbnailDescription')}`,
          },
          {
            key: 'Manual',
            text: i18n.getString('ImageExperience_ManualThumbnail'),
          },
        ]}
      />
    </div>
  );
};

EditThumbnail.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onThumbnailModeChanged: PropTypes.func,
  mode: PropTypes.string.isRequired,
};

EditThumbnail.defaultProps = {
  onThumbnailModeChanged: _.noop,
};
